import React from 'react';
import { i18n } from 'core/i18n';
import { openBase64pdfInPrintWindow } from 'utilities/pdfDocumentsHelper';
import getExtension from 'utilities/mimeTypeToExt';
import { downloadAsFile, base64ToBlob } from 'utilities/APIRequestHelper';
import { OKPdfViewer } from 'commonsComponents/OKPdfViewer';
import { LoadingSection } from 'commonsComponents/loadingSection';

const { FormattedText, formatText } = i18n;

export const HireNewCreditCardPdf = ({
    hireNewCreditCard,
    setPrintOffice,
    onDownloadPdf,
    onPrintPdf,
    scrollButtonAction,
    onClickPdfLink
}) => {
    const documentDIR = hireNewCreditCard.get('documentDIR');
    const documentINE = hireNewCreditCard.get('documentPolicy');
    const scale = 1.05;
    const viewerHeight = 480;
    const base64 = documentINE;
    const contentType = "application/pdf";
    const document = `data:${contentType};base64,${base64}`;

    const openPdfInNewTab = (documentKey, documentKeyPO) => {
        const document = hireNewCreditCard.get(documentKey);
        const pdf = `data:${contentType};base64,${document}`;
        if (document) {
            openBase64pdfInPrintWindow(pdf, true);
        }
        const title = formatText(documentKeyPO);
        if (onClickPdfLink) {
            onClickPdfLink(documentKey, title);
        }
    }
    const handleDownloadPdf = () => {
        let fileName = formatText(`hireCardOpenCreditStepPolicy-pdfDownload`) + "." + getExtension(contentType);
        downloadAsFile(base64ToBlob(document), contentType, fileName);
    if (onDownloadPdf) {
            onDownloadPdf();
        }

    }
    const handleOnPrint = () => {
        if (onPrintPdf) {
            onPrintPdf();
        }
        if (documentINE) {
            const data = [base64ToBlob(document)];
            const blobObject = new Blob(data, { type: `${contentType};base64` });
            const blobURL = URL.createObjectURL(blobObject);
            const winparams = `dependent=yes,locationbar=no,scrollbaars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=${screen.width},height=${screen.height}`;
            const printWindow = window.open(blobURL, '', winparams);
            setPrintOffice(true);

            if (printWindow) {
                printWindow.print();
            }
        }
    }
    return (
        <>
            <div>
                <h4 className="contract-loan-pdf-viewer__subtitle">
                    <strong>
                        <FormattedText value={`overdraftProtectionLoan-subtitleConfirmPage`} />
                    </strong>
                </h4>
                <div className="contract-actions-readed contract-payrollLoan-readed">
                    <button className="link--red option-link-cards-color-blue" onClick={() => openPdfInNewTab('documentINE', 'hireCardOpenCredit-hireCardOpenCredit_legalText' )}>
                        <FormattedText value={'hireCardOpenCredit-hireCardOpenCredit_legalText'} />
                    </button>
                    <span>
                        <i className="signature-pattern-code-input__icon icon icon-check" />
                        <FormattedText className="signature-text" value={'hireCardOpenCredit-hireCardOpenCredit_legalTextRead'} />
                    </span>
                </div>
                {documentDIR && (
                    <div className="contract-actions-readed contract-payrollLoan-readed">
                        <button className="link--red option-link-cards-color-blue" onClick={() => openPdfInNewTab('documentDIR', 'hireCreditCard-documentNameDir')}>
                            <FormattedText value={'hireCreditCard-documentNameDir'} />
                        </button>
                        <span>
                            <i className="signature-pattern-code-input__icon icon icon-check" />
                            <FormattedText className="signature-text" value={'hireCardOpenCredit-hireCardOpenCredit_legalTextRead'} />
                        </span>
                    </div>
                )}
            </div>
            <br />
            {documentINE ?
                <OKPdfViewer
                    onDownload={() => handleDownloadPdf()}
                    pdfFile={document}
                    scale={scale}
                    viewerHeight={viewerHeight}
                    onPrint={() => handleOnPrint()}
                    title={formatText(`hireCardOpenCreditStepPolicy-titlePdfWP`)}
                    showScroll
                    scrollButtonAction={scrollButtonAction}
                />
                : <LoadingSection />
            }
        </>
    );
};

